export default theme => ({
  container: {
    padding: 16,
    marginBottom: 26,
  },
});
